module.exports = __webpack_public_path__ + "img/jambyl4.25a2ea3d.jpg";